import React from 'react';
import PropTypes from 'prop-types';

function UpArrow({ active, activeColor, color }) {
  return (
    <path
      d="M180.555 163.016H201.53C205.399 163.016 208.535 166.152 208.535 170.021V188.352C208.535 190.21 207.797 191.991 206.483 193.305L196.317 203.472C193.581 206.207 189.146 206.207 186.41 203.472L175.909 192.969C174.624 191.685 173.889 189.952 173.857 188.136L173.551 170.141C173.484 166.226 176.639 163.016 180.555 163.016Z"
      fill={active ? activeColor : color}
    />
  );
}

UpArrow.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

UpArrow.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#4F535E',
};

export default UpArrow;
